// biomedicalEngineeringData.js

const biomedicalEngineeringData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "39",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34", code: "MATH 34", title: "Calculus II", credit: 4 },
        { id: "MATH42", code: "MATH 42", title: "Calculus III", credit: 4 },
        { id: "MATH51", code: "MATH 51", title: "Differential Equations", credit: 4 },
        { id: "PROBSTAT", code: "", title: "Probability & Statistics (a)", credit: "3-5" },
        { id: "CHEM1", code: "CHEM 1 / CHEM 11", title: "Gen. Chem. I w/ lab or Exp. Gen. Chem. I w/ lab", credit: "5-6" },
        { id: "CHEM2", code: "CHEM 2 / CHEM 12", title: "Gen. Chem. II w/ lab or Exp. Gen. Chem. II w/ lab", credit: "5-6" },
        { id: "PHY11", code: "PHY 11", title: "Gen. Physics I w/ lab", credit: 5 },
        { id: "PHY12", code: "PHY 12", title: "Gen. Physics II w/ lab", credit: 5 },
      ],
    },
    {
      section: "Engineering & Computing Fund",
      subtotal: "7",
      courses: [
        { id: "EN1", code: "EN 1", title: "Applications in Engineering", credit: 3 },
        { id: "ES2", code: "ES 2", title: "Intro. Comp. in Eng. or CS 11 Intro. Comp. Sci", credit: 4 },
      ],
    },
    {
      section: "Communication",
      subtotal: "7",
      courses: [
        { id: "ENG1", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        { id: "BME6", code: "BME 6", title: "Scientific Reading, Writing & Presentations", credit: 3 },
        { id: "ES85", code: "ES 85", title: "Professional Preparation for Cooperative Education", credit: 1 },
      ],
    },
    {
      section: "HASS Electives",
      subtotal: "17",
      courses: [
        { id: "HASS_Humanities", code: "Humanities Elective", title: "Humanities Elective (b)", credit: "≥3" },
        { id: "HASS_Social", code: "Social Science Elective", title: "Social Science Elective (c)", credit: "≥3" },
      ],
    },
    {
      section: "Electrical Systems & Optics",
      subtotal: "6",
      courses: [
        { id: "BME10", code: "BME 10", title: "Elec. Circ. & BME Appl.", credit: 3 },
        { id: "ES15", code: "ES 15", title: "Mod. Optics & Photonics", credit: 3 },
      ],
    },
    {
      section: "Biomedical Engineering Core",
      subtotal: "36",
      courses: [
        { id: "BME11", code: "BME 11", title: "Biomechanics", credit: 3 },
        { id: "BME12", code: "BME 12", title: "Biothermodynamics", credit: 3 },
        { id: "BME33", code: "BME 33", title: "Mol. Cell., & Prot. I", credit: 5 },
        { id: "BME34", code: "BME 34", title: "Mol. Cell., & Prot. II", credit: 5 },
        { id: "BME44", code: "BME 44", title: "Tis. Org. & Syst. I", credit: 5 },
        { id: "BME45", code: "BME 45", title: "Tis. Org. & Syst. II", credit: 5 },
        { id: "BME66", code: "BME 66", title: "Eng. Dsn. Process", credit: 3 },
        { id: "BME100", code: "BME 100", title: "Dsn. Med. Instrum.", credit: 3 },
        { id: "BME151", code: "BME 151", title: "Intro. Biophotonics", credit: 4 },
      ],
    },
    {
      section: "Technical Electives",
      subtotal: "13",
      courses: [
        { id: "TE1", code: "Technical Elective (e)", title: "", credit: "3-4" },
        { id: "TE2", code: "Technical Elective (e) or (f)", title: "", credit: "3-4" },
        { id: "TE3", code: "Technical Elective (f)", title: "", credit: "3-4" },
        { id: "TE4", code: "Technical Elective (f)", title: "", credit: "3-4" },
        { id: "TE5", code: "Technical Elective (g)", title: "", credit: "1-5" },
      ],
    },
    {
      section: "Capstone Project (A, B or C)",
      subtotal: "5",
      courses: [
        { id: "CAP_A1", code: "A BME 7", title: "Senior Capstone I", credit: 3 },
        { id: "CAP_A2", code: "BME 8", title: "Senior Capstone II", credit: 3 },
        { id: "CAP_B",  code: "BME 9", title: "Senior Project", credit: 5 },
        { id: "CAP_C1", code: "C BME 89", title: "Honors Thesis A", credit: 3 },
        { id: "CAP_C2", code: "BME 90", title: "Honors Thesis B", credit: 3 },
      ],
    },
  ];
  
  export default biomedicalEngineeringData;
  